import { useState } from "react";
import type { BookedFlightItinerary } from "@b2bportal/air-booking-api";
import { useFlightStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreFlightsComponent,
  type ScheduleChangeDiffModel,
} from "@b2bportal/core-types";
import { FlightScheduleChangeModalContent } from "@tenant/flights";
import {
  Button,
  ButtonTypeEnum,
  Dialog,
  DialogContent,
  DialogTrigger,
} from "@tenant/ui";

import defaultStyles from "./FlightScheduleChangeModal.module.scss";

export interface IFlightScheduleChangeModalProps {
  hoursToDeparture?: number;
  itinerary: BookedFlightItinerary;
  scheduleChangeDiffs: ScheduleChangeDiffModel;
  triggerCtaLabel?: string;
}

export const FlightScheduleChangeModal = (
  props: IFlightScheduleChangeModalProps
) => {
  const { triggerCtaLabel, ...modalContentProps } = props;
  const COMPONENT_KEY = CoreFlightsComponent.FlightScheduleChangeModal;
  const styles = useFlightStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button
          className={cn("dialog-trigger")}
          buttonType={ButtonTypeEnum.Primary}
          onClick={(e) => e.stopPropagation()}
        >
          {triggerCtaLabel}
        </Button>
      </DialogTrigger>
      <DialogContent className={block} onClick={(e) => e.stopPropagation()}>
        <FlightScheduleChangeModalContent
          {...modalContentProps}
          closeModal={() => setIsOpen(false)}
        />
      </DialogContent>
    </Dialog>
  );
};
